// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-green-button_button__5z-T8 {
  width: fit-content;
  height: fit-content;
  /* Responsive padding and margin */
  padding: clamp(10px, 1.2vh, 16px) clamp(24px, 3vw, 40px);
  margin: clamp(16px, 2.5vh, 30px);
  background: #273400;
  border-radius: 30px;
  color: white;
  cursor: pointer;
  font-size: clamp(14px, 1.2vw, 18px);
  font-weight: 500;
  border: none;
  transition: background 0.2s ease, transform 0.15s ease;
}

.dark-green-button_button__5z-T8:hover:not(:disabled) {
  background: #3a4d00;
  transform: scale(1.02);
}

.dark-green-button_button__5z-T8:active:not(:disabled) {
  transform: scale(0.98);
}

.dark-green-button_button__5z-T8:disabled,
.dark-green-button_button__5z-T8:disabled:hover,
.dark-green-button_button__5z-T8:disabled:active {
  background: #273400B2;
  cursor: auto;
  transform: none;
}

/* Style for the arrow icon */
.dark-green-button_icon__qer8k {
  font-size: clamp(10px, 1vw, 14px);
  color: white;
  position: relative;
}

.dark-green-button_spinner__aKuhK {
  animation: dark-green-button_spin__6Cprz 1s linear infinite;
}

/* Keyframes for rotation */
@keyframes dark-green-button_spin__6Cprz {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Buttons/dark-green-button.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,wDAAwD;EACxD,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2DAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".button {\n  width: fit-content;\n  height: fit-content;\n  /* Responsive padding and margin */\n  padding: clamp(10px, 1.2vh, 16px) clamp(24px, 3vw, 40px);\n  margin: clamp(16px, 2.5vh, 30px);\n  background: #273400;\n  border-radius: 30px;\n  color: white;\n  cursor: pointer;\n  font-size: clamp(14px, 1.2vw, 18px);\n  font-weight: 500;\n  border: none;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.button:hover:not(:disabled) {\n  background: #3a4d00;\n  transform: scale(1.02);\n}\n\n.button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.button:disabled,\n.button:disabled:hover,\n.button:disabled:active {\n  background: #273400B2;\n  cursor: auto;\n  transform: none;\n}\n\n/* Style for the arrow icon */\n.icon {\n  font-size: clamp(10px, 1vw, 14px);\n  color: white;\n  position: relative;\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n/* Keyframes for rotation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `dark-green-button_button__5z-T8`,
	"icon": `dark-green-button_icon__qer8k`,
	"spinner": `dark-green-button_spinner__aKuhK`,
	"spin": `dark-green-button_spin__6Cprz`
};
export default ___CSS_LOADER_EXPORT___;
